package one.healthium.settings.ui.meal_plan

import androidx.compose.runtime.Immutable
import one.healthium.loco.LString

@Immutable
internal data class MealPlanUiModel(
    val id: String,
    val name: LString,
    val checked: Boolean,
)
